import { useQueryClient } from "@tanstack/react-query";
import type { FunctionComponent } from "react";
import { useCallback } from "react";

import Sidebar from "~/components/Sidebar/Sidebar";
import {
	STAFF_MEMBERS_FTE_PERCENTAGES_QUERY_KEY,
} from "~/modules/humanResources/api/staffMemberFtePercentage/staffMemberFtePercentageQueries.ts";
import CreateFtePercentageEntryForm
	from "~/modules/humanResources/components/StaffMemberDetailsView/components/StaffMemberPaymentsSection/components/CompensationComponentsOverview/components/CreateFtePercentageEntrySidebar/components/CreateFtePercentageEntryForm";

type Props = {
	isOpen: boolean;
	onClose: () => void;
	staffMemberId: string;
};

const CreateFtePercentageEntrySidebar: FunctionComponent<Props> = ({
	isOpen,
	onClose,
	staffMemberId,
}) => {

	const queryClient = useQueryClient();
	const handleSuccess = useCallback(async () => {
		await queryClient.refetchQueries({ queryKey: STAFF_MEMBERS_FTE_PERCENTAGES_QUERY_KEY(staffMemberId) });
		onClose();
	}, [onClose, queryClient, staffMemberId]);

	return (
		<Sidebar closeOnOutsideClick={false}
				 open={isOpen}
				 setOpen={() => onClose()}>
			<CreateFtePercentageEntryForm
				key={isOpen ? "open" : "closed"}
				onSuccess={handleSuccess}
				onCancel={onClose}
				staffMemberId={staffMemberId} />
		</Sidebar>
	);
};

export default CreateFtePercentageEntrySidebar;
